import Dexie from "dexie";

// ── IndexedDB schema via Dexie ────────────────────────────────────────────────
const db = new Dexie("PharmacyOfflineDB");

db.version(1).stores({
  // MongoDB _id stored as string primary key
  sessions: "_id, session, current",
  students: "_id, reg_no, level",
  results: "_id, student_id, session, semester, level",
  courses: "_id, code, level, semester, type",
  departments: "_id, code",
  // Sync metadata
  sync_meta: "key",
});

export default db;
